import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import SFDialog from "../../dialog";

const ConfirmationDialog = ({ message, onClose, onConfirm, open }) => {
  const { t } = useTranslation();
  return (
    <SFDialog
      variant="info"
      title={t(
        "components.datagrid.filters.advancedQuery.confirmationDialog.header"
      )}
      message={message}
      open={open}
      onClose={onClose}
      primaryButton
      primaryButtonProps={{
        label: t("components.dialog.submitButtonLabel"),
        onClick: onConfirm,
      }}
      secondaryButton
      secondaryButtonProps={{
        label: t("components.dialog.cancelButtonLabel"),
        onClick: onClose,
      }}
    />
  );
};

ConfirmationDialog.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationDialog;
